module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAS5JREFUSEut1rFSwzAMgOFfIwOvBQcTmVjhKThg5j0YYYIF7ngtGMqmnoLDhWBLSp2ObaovsiVboqo3wD3wDlyJyDcbfFT1CHgEzoAHUdVP4LjE/gAuerGCvACnJe6XQU/A5SyJLqyCWOhngyzFV+CkF2sg9uKDWPAtMBcR2Y1QLxYhFv8XOhTLIP+gtVgWqUJZbA3ShCKsLHmtUgcR2dX6/c8eLR9wqtH+t2yHJuJmFFTj/J1++qSRyfSgm1ECSyGpjJz9sp+2gxr7tO3SOcVg0HQypzJr7pGDDCWd+TUQYlXIQ6bq6m7YDLKoxlRm2UO12SfZzDLXRNiMGSy6+EIku4zeVZ5GUlhjOFmNBNg4nCzHrYMRBxvHrVvgDngDrqNTuHbX1L6bDZDnNkDuAYyEBEcfo5xuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/close-icon.png
// module id = yDSG
// module chunks = 1